import api from 'common/api';

export const getDocumentApprovalAPI = (params: any) => api.get('/approval-document/list', params);

export const updateDocumentApprovalAPI = (params: any) => api.put('/approval-document', params);

export const DOWNLOAD_APPROVAL_DOCUMENT_API = '/approval-document/download';
